export default __webpack_public_path__ + "static/media/landing_mat_detail_mem.74cf6c70.png";